import React, { useState, useEffect } from "react";
import "../../Styles/SekeBashgah.css";
import Page from "../Page/Page";
import ModalCS from "../../Components/componentBashgah/ModalCS";
import ModalHelpCS from "../../Components/componentBashgah/ModalHelpCS";

import {
  Transaction_Club,
  Transaction_Profile,
} from "../../Connections/Transaction";

import { Swiper, SwiperSlide } from "swiper/react";
import { useLocation, useNavigate } from "react-router";
import MobileNavBar from "../../Components/Navs/MobileNavBar";
import PictureProfile from "../../Containers/Profile/PictureProfile";

const SekeBashgah = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const { from } = location.state;
  // ==================================================

  const [showHistory, setShowHistory] = useState(true);

  const [myCoinList, setMyCoinList] = useState([]);
  const [coinHelpList, setCoinHelpList] = useState([]);

  const [user, setUser] = useState({});

  //  ==================================================

  useEffect(() => {
    Transaction_Club.GetMyCoins()
      .then((res) => {
        if (res[0]) {
          setMyCoinList(res[2].data);
        }
      })
      .catch((err) => console.log(err));

    Transaction_Club.GetCoinHelps()
      .then((res) => {
        if (res[0]) {
          setCoinHelpList(res[2].data);
        }
      })
      .catch((err) => console.log(err));

    Transaction_Profile.GetProfile()
      .then((res) => {
        if (res[0]) {
          setUser(res[2].data);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  //  ==================================================

  return (
    <Page>
      <MobileNavBar text={"سکه‌های من"} action={() => navigator(-1)} />
      <div className="mobile-hidden">
        <div className="SekeBashgah">
          <div
            className="SekeBashgah_back-arrow mobile-hidden"
            onClick={() => navigator(-1)}
          >
            <svg
              width="8"
              height="15"
              viewBox="0 0 8 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.16984 15C1.31923 15.0005 1.46684 14.9675 1.60182 14.9035C1.7368 14.8395 1.85572 14.746 1.94984 14.63L6.77984 8.63C6.92692 8.45107 7.00732 8.22663 7.00732 7.995C7.00732 7.76338 6.92692 7.53893 6.77984 7.36L1.77984 1.36C1.6101 1.15578 1.36619 1.02736 1.10176 1.00298C0.837334 0.978601 0.574053 1.06026 0.369836 1.23C0.16562 1.39974 0.0371957 1.64365 0.012816 1.90808C-0.0115638 2.1725 0.0700977 2.43578 0.239836 2.64L4.70984 8L0.389837 13.36C0.267554 13.5068 0.189877 13.6855 0.165997 13.8751C0.142118 14.0646 0.173034 14.257 0.25509 14.4296C0.337146 14.6021 0.466906 14.7475 0.629016 14.8486C0.791127 14.9497 0.978803 15.0022 1.16984 15Z"
                fill="#ffffff"
              />
            </svg>
          </div>
          <div className="SekeBashgah-inside">
            <div className="SekeBashgah-inside-item1 mobile-hidden">
              <div className="SekeBashgah-inside-item1-reght">
                <div className="SekeBashgah-inside-item1-reght-text">
                  <p className="SekeBashgah-inside-item1-reght-name">
                    {user.name?.length > 2 ? user.name : "کاربر"}
                  </p>
                  <p className="SekeBashgah-inside-item1-reght-number number-font">
                    {user.mobile}
                  </p>
                </div>
              </div>
              <div className="SekeBashgah-inside-item1-left">
                <div className="Bashgah-inside-item1-left">
                  <div className="Profile-top">
                    <div className="Profile-top-right">
                      <div className="Profile-top-right-inside">
                        <div className="Profile-top-right-inside-text">
                          {/* <div className="Profile-top-right-inside-text-display">
                        <p
                          className="Profile-top-right-inside-text-name"
                          style={{ textAlign: "center" }}
                        >
                          {user.name || "کاربر"}
                        </p>
                        <p className="Profile-top-right-inside-text-phone number-font">
                          {user.mobile}
                        </p>
                      </div> */}
                        </div>
                      </div>
                    </div>
                    <div className="Profile-top-left">
                      <PictureProfile
                        profileSrc={user.avatar}
                        iconChange={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {localStorage.getItem("Token") && myCoinList.length > 0 ? (
              <div className="SekeBashgah-inside-item2">
                <div className="SekeBashgah-inside-item2-top mobile-hidden">
                  <div className="SekeBashgah-inside-item2-top-border">
                    <p className="SekeBashgah-inside-item2-top-border-title">
                      تاریخچه سکه
                    </p>
                  </div>
                </div>
                <div className="SekeBashgah-inside-item2-bottom">
                  <Swiper
                    spaceBetween={20}
                    // breakpoints={{
                    //   640: { slidesPerView: 3 },
                    //   992: { slidesPerView: 4 },
                    //   1300: {
                    //     slidesPerView: myCoinList.length,
                    //   },
                    // }}
                    breakpoints={{
                      1440: {
                        slidesPerView: 5,
                      },
                      1300: {
                        slidesPerView: 4,
                      },
                      1200: {
                        slidesPerView: 3,
                      },
                      1100: {
                        slidesPerView: 3,
                      },
                      992: {
                        slidesPerView: 3,
                      },
                      900: {
                        slidesPerView: 2.9,
                      },
                      800: {
                        slidesPerView: 2.75,
                      },
                      768: {
                        slidesPerView: 2,
                      },
                    }}
                    slidesPerView={2}
                  >
                    {myCoinList.map((item, i) => (
                      <SwiperSlide key={i}>
                        <ModalCS
                          img={"/imgs/Bashgah/modal-c.svg"}
                          title={`${item.numberOfCoin} سکه`}
                          time={item.date}
                          text={item.description}
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            ) : null}

            <div className="SekeBashgah-inside-item3">
              <div className="SekeBashgah-inside-item3-top mobile-hidden">
                <div className="SekeBashgah-inside-item3-top-border">
                  <p className="SekeBashgah-inside-item3-top-border-title">
                    راهنمای دریافت سکه
                  </p>
                </div>
              </div>
              <div className="SekeBashgah-inside-item3-bottom">
                <Swiper
                  spaceBetween={20}
                  breakpoints={{
                    640: { slidesPerView: 3 },
                    992: { slidesPerView: 4 },
                    1300: { slidesPerView: 5 },
                  }}
                  slidesPerView={1.5}
                >
                  {coinHelpList.map((item, i) => (
                    <SwiperSlide key={i}>
                      <ModalHelpCS
                        img={"/imgs/Bashgah/modal-c.svg"}
                        title={`${item.numberOfCoin} سکه`}
                        text={item.description}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="desktop-hidden">
        <div className="SekeBashgah">
          <div className="SekeBashgah-res">
            <div className="SekeBashgah-res-inside">
              <div
                className={`SekeBashgah-res-inside-right ${
                  showHistory ? "active" : ""
                }`}
                onClick={() => setShowHistory(true)}
              >
                <p className="SekeBashgah-res-inside-right-text">
                  تاریخچه سکه‌
                </p>
              </div>
              <div
                className={`SekeBashgah-res-inside-left ${
                  showHistory ? "" : "active"
                }`}
                onClick={() => setShowHistory(false)}
              >
                <p className="SekeBashgah-res-inside-left-text">
                  راهنمای دریافت سکه‌
                </p>
              </div>
            </div>
          </div>
          {showHistory ? (
            <div className="SekeBashgah-inside-item2-bottom">
              {myCoinList.length > 0 ? (
                myCoinList.map((item, i) => (
                  <ModalCS
                    key={i}
                    img={"/imgs/Bashgah/modal-c.svg"}
                    title={`${item.numberOfCoin} سکه`}
                    time={item.date}
                    text={item.description}
                  />
                ))
              ) : (
                <div className="SekeBashgah-inside-item2-bottom-no-coin">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="65"
                    height="64"
                    viewBox="0 0 65 64"
                    fill="none"
                  >
                    <g opacity="0.3">
                      <path
                        d="M57.4932 13.1001L57.6023 13.265C57.6661 13.3793 57.7219 13.4963 57.7937 13.6027C61.2264 18.6281 63.0956 24.1852 63.2897 30.2609C63.5397 38.0968 61.1732 45.0898 56.2595 51.2107C48.514 60.8546 35.2911 65.0185 23.4349 61.5965C19.9703 60.5967 16.7956 59.0386 13.8122 57.0497L13.6501 56.9433C13.5384 56.7625 13.3735 56.6562 13.1714 56.603C10.9645 54.8135 8.88524 52.8938 7.14895 50.6284C3.32274 45.6508 1.12912 40.0485 0.65849 33.776C-0.335952 20.5053 6.96814 8.2263 19.1248 2.73826C32.1935 -3.15926 47.8067 0.709489 56.645 12.0339C56.8046 12.2386 56.9827 12.4301 57.1529 12.6268C57.2087 12.8263 57.3124 12.9911 57.4932 13.1028V13.1001ZM31.9542 3.58912C16.6201 3.56785 4.18424 15.9691 4.13106 31.3298C4.08054 46.6825 16.5323 59.1742 31.9116 59.1928C47.2457 59.2141 59.6789 46.8154 59.7347 31.4495C59.7906 16.0994 47.3335 3.60773 31.9515 3.58646L31.9542 3.58912Z"
                        fill="#EFEFEF"
                      />
                      <path
                        d="M12.691 56.2202C15.6743 58.2091 19.6095 60.4 23.0714 61.3998C34.9276 64.8218 48.1532 60.658 55.896 51.014C60.8097 44.8931 63.1735 37.8975 62.9262 30.0642C62.7321 23.9886 60.8948 18.4208 57.4621 13.3954C57.3903 13.289 55.1808 10.3403 55.1169 10.2286C55.7764 10.2924 58.0763 13.7384 58.3768 14.1505C60.9746 17.7135 62.7321 21.6673 63.6734 25.9721C64.269 28.6949 64.5562 31.4602 64.3754 34.2388C64.0776 38.7776 62.9821 43.1223 60.823 47.1532C59.6079 49.4213 58.1481 51.5139 56.4411 53.4602C53.737 56.5446 50.5276 58.9403 46.8875 60.7537C43.8032 62.2905 40.538 63.277 37.092 63.7264C31.1413 64.5028 25.4751 63.62 20.019 61.1685C17.8094 60.1767 15.7567 58.9429 13.8449 57.4593C13.6322 57.2944 12.6325 56.5472 12.6856 56.2202H12.691Z"
                        fill="#A7A7A7"
                      />
                      <path
                        d="M31.9534 3.5892C47.3354 3.61047 59.7898 16.0995 59.7367 31.4522C59.6808 46.8182 47.2476 59.2168 31.9135 59.1955C16.5343 59.1743 4.0798 46.6826 4.13298 31.3325C4.1835 15.9692 16.6193 3.56793 31.9534 3.5892ZM31.9375 5.7004C17.8105 5.69508 6.22822 17.2827 6.24418 31.407C6.25747 45.5126 17.7653 57.0338 31.8896 57.0817C45.9926 57.1322 57.5989 45.5552 57.6228 31.415C57.6467 17.296 46.0697 5.70571 31.9375 5.7004Z"
                        fill="#848484"
                      />
                      <path
                        d="M31.9394 5.70044C46.0743 5.70576 57.6513 17.2961 57.6247 31.415C57.6008 45.5552 45.9945 57.1322 31.8915 57.0817C17.7673 57.0312 6.2594 45.51 6.24611 31.407C6.23281 17.2828 17.8125 5.69512 31.9394 5.70044ZM10.4765 31.3991C10.8009 43.7179 20.2055 52.8248 31.966 52.7822C44.0163 52.7397 53.2827 43.4759 53.3279 31.4203C53.3704 19.6333 44.2742 10.0186 31.95 10.0026C19.9077 9.98665 10.7822 19.3169 10.4791 31.3991H10.4765Z"
                        fill="#E8E8E8"
                      />
                      <path
                        d="M10.4753 31.399C10.7784 19.3168 19.9039 9.98663 31.9462 10.0026C44.2704 10.0185 53.3693 19.6333 53.3241 31.4203C53.2789 43.4759 44.0151 52.7397 31.9622 52.7822C20.2017 52.8247 10.797 43.7179 10.4727 31.399H10.4753ZM30.4253 24.7863C30.4838 24.9192 30.521 24.9644 30.521 25.0096C30.5264 29.1629 30.5264 33.3161 30.537 37.4694C30.537 37.8815 30.3881 38.0225 29.9839 38.0145C28.9602 37.9985 27.9339 37.9852 26.9102 38.0251C25.7163 38.073 25.1234 38.7749 25.1207 40.0539C25.1207 41.3488 25.6977 42.1039 26.8756 42.1119C30.9225 42.1465 34.9721 42.1438 39.019 42.1119C40.1544 42.1013 40.7872 41.2664 40.7686 40.0167C40.75 38.8175 40.1145 38.0783 38.9924 38.0225C38.1788 37.9826 37.3598 37.9586 36.5488 38.0171C35.8389 38.0677 35.6687 37.8204 35.6741 37.1317C35.7033 31.9548 35.69 26.7752 35.6873 21.5982C35.6873 21.311 35.6873 21.0186 35.6528 20.7341C35.4613 19.2663 34.8285 18.7345 33.3501 18.7505C32.837 18.7558 32.3637 18.8834 31.9063 19.0908C30.2711 19.8274 28.822 20.8856 27.2771 21.7764C26.7108 22.1034 26.1205 22.4012 25.6525 22.8798C24.8921 23.6642 24.807 24.7171 25.4425 25.6052C26.1045 26.5279 26.9315 26.7353 27.9897 26.1822C28.8007 25.7594 29.5798 25.2729 30.428 24.7836L30.4253 24.7863Z"
                        fill="#AEAEAE"
                      />
                      <path
                        d="M30.4215 24.7863C29.5733 25.2755 28.7942 25.7621 27.9833 26.1849C26.925 26.7379 26.0954 26.5305 25.436 25.6079C24.8005 24.7198 24.8856 23.6642 25.6461 22.8825C26.1114 22.4012 26.7017 22.1061 27.2707 21.779C28.8155 20.8856 30.2646 19.8274 31.8999 19.0935C32.3572 18.8861 32.8332 18.7585 33.3437 18.7532C34.8221 18.7372 35.4549 19.269 35.6463 20.7367C35.6835 21.0212 35.6809 21.3137 35.6809 21.6009C35.6809 26.7778 35.6942 31.9574 35.6676 37.1344C35.6649 37.8204 35.8351 38.0703 36.5424 38.0198C37.3534 37.9613 38.1723 37.9852 38.986 38.0251C40.108 38.081 40.7462 38.8175 40.7621 40.0193C40.7807 41.269 40.1479 42.1039 39.0125 42.1146C34.9656 42.1491 30.9161 42.1491 26.8692 42.1146C25.6886 42.1039 25.1116 41.3515 25.1143 40.0565C25.1143 38.7776 25.7099 38.0756 26.9037 38.0278C27.9274 37.9879 28.9538 38.0012 29.9775 38.0171C30.3843 38.0225 30.5332 37.8815 30.5305 37.4721C30.5172 33.3188 30.5199 29.1655 30.5146 25.0123C30.5146 24.9671 30.4774 24.9219 30.4189 24.7889L30.4215 24.7863Z"
                        fill="#AEAEAE"
                      />
                      <path
                        d="M44.9908 35.1162C44.5734 35.1427 44.2277 34.9513 43.9405 34.6269C41.8905 32.3216 39.8431 30.0137 37.7904 27.7084C36.9023 26.7086 36.0036 25.7168 35.1155 24.7197C34.1902 23.6801 33.2702 22.6351 32.3449 21.5955C31.8663 21.0557 31.7998 20.3404 32.1854 19.7183C32.5736 19.0881 33.3261 18.7717 33.9881 18.9418C34.3019 19.0243 34.5518 19.1838 34.7672 19.4284C36.6524 21.5476 38.5455 23.6641 40.4334 25.7806C41.4305 26.9 42.4249 28.0195 43.422 29.1415C44.3819 30.2211 45.3338 31.3086 46.2963 32.3854C46.7723 32.9172 46.876 33.5128 46.5915 34.151C46.3469 34.6987 45.7805 35.1933 44.9908 35.1162Z"
                        fill="white"
                      />
                      <path
                        d="M35.2556 17.2667C35.2848 16.5781 35.7183 15.9984 36.3883 15.7591C37.0158 15.5331 37.63 15.6953 38.1113 16.2324C39.1031 17.3412 40.0922 18.4526 41.076 19.5694C41.7487 20.3325 41.3339 21.7204 40.3315 22.0741C39.6136 22.3267 39.0419 22.1751 38.5288 21.5981C37.5476 20.4947 36.5665 19.3886 35.5853 18.2851C35.3274 17.9953 35.2237 17.6549 35.2556 17.2694V17.2667Z"
                        fill="white"
                      />
                      <path
                        d="M39.8121 33.2178C40.2056 33.2178 40.538 33.372 40.7906 33.6539C41.8488 34.8318 42.9124 36.0044 43.9414 37.2089C44.6381 38.0251 43.984 39.5035 42.8805 39.6976C42.2477 39.8093 41.7425 39.6232 41.3224 39.1446C40.3625 38.0517 39.392 36.9696 38.4294 35.8794C38.0013 35.3928 37.9109 34.7228 38.23 34.1351C38.565 33.5183 39.1021 33.2072 39.8121 33.2178Z"
                        fill="white"
                      />
                    </g>
                  </svg>
                  <p>هنوز سکه‌ای نگرفتی!</p>
                </div>
              )}
            </div>
          ) : (
            <div className="SekeBashgah-inside-item3-bottom">
              {coinHelpList.map((item) => (
                <ModalHelpCS
                  img={"/imgs/Bashgah/modal-c.svg"}
                  title={`${item.numberOfCoin} سکه`}
                  text={item.description}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </Page>
  );
};
export default SekeBashgah;
